module.exports = __webpack_public_path__ + "static/media/FrontLeft.c6fbecfb.jpg";